module.exports = __webpack_public_path__ + "static/media/milky-way.80fa0223.webp";